import { render, staticRenderFns } from "./paycenterOrderMang.vue?vue&type=template&id=0229a43a&"
import script from "./paycenterOrderMang.vue?vue&type=script&lang=js&"
export * from "./paycenterOrderMang.vue?vue&type=script&lang=js&"
import style0 from "./paycenterOrderMang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0229a43a')) {
      api.createRecord('0229a43a', component.options)
    } else {
      api.reload('0229a43a', component.options)
    }
    module.hot.accept("./paycenterOrderMang.vue?vue&type=template&id=0229a43a&", function () {
      api.rerender('0229a43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/paycenterOrderMang.vue"
export default component.exports